"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasBboxes = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../../utils");
var draw_bbox_1 = require("../functions/draw/draw-bbox");
exports.CanvasBboxes = (0, react_1.memo)(function (_a) {
    var bboxStyle = _a.bboxStyle, canvasSize = _a.canvasSize, bboxes = _a.bboxes, mode = _a.mode;
    var _b = tslib_1.__read((0, utils_1.useCanvasContext2d)(), 2), ctx = _b[0], canvasRef = _b[1];
    (0, react_1.useEffect)(function () {
        if (ctx === undefined)
            return;
        (0, utils_1.resetAndDrawOnCanvas)(ctx, canvasSize, function () {
            if (mode !== 'rectbox-editor-add-bbox' &&
                mode !== 'rectbox-editor-resize-bbox' &&
                mode !== 'auto-segmentation-crop') {
                /* canvasは色を頻繁に変えない方が描画が速いため，
                    同じ色のオブジェクトを連続して描いている */
                bboxes
                    .groupBy(function (bb) { return bb.label; })
                    .forEach(function (bboxesGroupedByLabel, label) {
                    var _a = tslib_1.__read(bboxStyle.borderColorSLA.notSelected, 3), s = _a[0], l = _a[1], a = _a[2];
                    var borderColorStr = (0, utils_1.hslaToStr)([label.hue, s, l, a]);
                    (0, draw_bbox_1.drawBboxes)(ctx, bboxesGroupedByLabel.toList(), {
                        showPoints: mode === 'rectbox-editor-standby',
                        pointWidthPx: bboxStyle.pointWidthPx,
                        borderWidthPx: bboxStyle.borderWidthPx.notSelected,
                        borderShadowWidthPx: bboxStyle.boxShadowWidthPx,
                        borderDashLengthPx: undefined,
                        borderColor: borderColorStr
                    });
                });
            }
        });
    });
    return (react_1.default.createElement("canvas", { ref: canvasRef, height: canvasSize.height, width: canvasSize.width }));
});
exports.CanvasBboxes.displayName = 'CanvasBboxes';
